import { FC, useEffect } from "react";
import { useFormikContext } from "formik";

type FormErrorHandlerProps = {
  action: () => void;
};

const FormErrorHandler: FC<FormErrorHandlerProps> = ({ action }) => {
  const { isValid, isValidating, isSubmitting } = useFormikContext();

  useEffect(() => {
    if (!isValid && !isValidating && isSubmitting) {
      action();
    }
  }, [action, isSubmitting, isValid, isValidating]);

  return null;
};

export default FormErrorHandler;
